import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DestroyableComponent } from '@models/destroyable.component';
import { Classroom } from 'lingo2-models';

@Component({
  selector: 'app-classroom-form-wrapper',
  templateUrl: './classroom-form-wrapper.component.html',
  styleUrls: ['./classroom-form-wrapper.component.scss'],
})
export class ClassroomFormWrapperComponent extends DestroyableComponent {
  @Input()
  classroom: Classroom;

  @Output()
  saved = new EventEmitter<Classroom>();

  @Output()
  canceled = new EventEmitter<void>();

  constructor() {
    super();
  }

  public onSaved(classroom: Classroom): void {
    this.saved.emit(classroom);
  }

  public onCanceled(): void {
    this.canceled.emit();
  }
}
